import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import ContactForm from '@src/features/company/contact/ContactForm';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';

function CompanyContactForm() {
  return (
    <CompanyGuard>
      <CompanyDefaultLayout
        pageName='contact'
        showSidebar={false}
      >
        <CommonHelmet />
        <ContactForm />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default CompanyContactForm;
